export default {
    text: {
        title: 'Text',
        addText: 'Neuer Text',
        fontFamily: 'Schriftfamilie',
        fontSize: 'Schriftgr.',
        textAlignment: 'Textausrichtung',
        fontColor: 'Schriftfarbe',
        lineSpacing: 'Zeilenabstand',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (serifenlos)',
        trebuchetMSSansSerif: 'Trebuchet MS (serifenlos)',
        timesNewRomanSerif: 'Times New Roman (serif) ist eine Schriftart',
        georgiaSerif: 'Georgia (Serife)',
        garamondSerif: 'Garamond (Serife)',
        courierNewMonospace: 'Courier New (monospace)',
        brushScriptMTCursive: 'Brush Script MT (Kursiv)',
        backgroundColor: 'Background color',
    },
};
